/** number.js, without animation  */
import { createNamespacedHelpers } from "vuex";
import { formatNumberWithComma } from "../../utils";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	props: {
		value: { type: [Number, String] },
		type: {
			/*
			 * type can be:
			 * - money - prints the outlet currency left of the number
			 * - gr - prints minor unit name to the right
			 * - gr-hidden - treats value as grams, but does not print units
			 * - kg - prints (major) unit name to the right
			 * - kg-hidden - treats value as kilograms, but does not print units (default)
			 */
			type: String,
			validator: function (value) {
				return ["money", "gr", "gr-hidden", "kg", "kg-hidden"].includes(value);
			},
		},
		inline: {
			type: Boolean,
			default: false,
		},
		showLess: {
			type: Boolean,
			default: false,
		},
		digits: {
			type: Number,
			default: undefined,
		},
		suffix: {
			type: String,
			default: "",
		},
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit", "weightUnitMinor", "weightFactor", "weightFactorMinor"]),

		scale() {
			if (this.type === "money") return 1;
			return this.type === "gr" || this.type === "gr-hidden" ? this.weightFactorMinor : this.weightFactor;
		},

		displayValue() {
			if (!this.value) return 0;
			return Number(this.value);
		},

		decimals() {
			if (this.digits === undefined) {
				// ounces have by default 1 decimal
				if ((this.type === "gr" || this.type === "gr-hidden") && this.weightUnitMinor !== "gr") return 1;
			}

			return Number(this.digits || 0);
		},

		formattedValue() {
			if (!this.displayValue) return "0";
			if (!this.digits && this.displayValue > 0 && this.displayValue < 1) return "<1";
			return formatNumberWithComma(this.displayValue * this.scale, this.decimals);
		},

		...userGetters(["activeOutlet"]),
	},
};
